import { lazy } from "react";

import useRecord from "../../api/api-hooks/records/useRecord";
import { View } from "../../types/PageInterfaces";
import useSubviewFlow from "../PageView/PageViewFlowChart/useSubviewFlow";
import WidgetError from "./WidgetError";

const AppFlowChart = lazy(
  () => import("../PageView/PageViewFlowChart/AppFlowChart")
);

interface Props {
  section: any;
  setSettings: any;
  view: View | undefined;
}

export interface SubviewFlowProps {
  pageID: string | undefined;
  parentViewID: string | undefined;
  drawerRecord: Record<string, any> | undefined;
}

export default function FlowWidget({
  section,
  setSettings,
  view,
  pageID,
  parentViewID,
  drawerRecord,
}: Props & SubviewFlowProps) {
  const isSubview = !!parentViewID;

  const { record: flowR, recordLoading: rLoading } = useRecord({
    moduleAPIName: "Flows",
    recordID: section?.RecordID || "",
    enabled: !isSubview,
  });
  const {
    flow: subviewFlow,
    flowLoading: swfLoading,
    flowError,
  } = useSubviewFlow({
    moduleAPIName: section?.ModuleAPIName,
    record: drawerRecord,
    pageID: pageID,
    parentViewID: parentViewID,
    viewID: view?._id,
    viewFilters: view?.ViewFilters,
    nodeDisplayFields:
      section?.FlowChartConfig?.Modules?.[section?.ModuleAPIName]?.Fields,
    parentField:
      section?.FlowChartConfig?.Modules?.[section?.ModuleAPIName]?.ParentField,
  });

  const flowRecord = isSubview ? subviewFlow : flowR;
  const loading = isSubview ? swfLoading : rLoading;

  if (loading && section?.RecordID) return null;

  if ((!flowRecord && !flowError) || !view) {
    return <WidgetError onOpenSettings={() => setSettings(section)} />;
  }

  return (
    <>
      <AppFlowChart
        view={view}
        chartName={section?.Name}
        flowRecord={flowError ? { Error: flowError } : flowRecord}
        useFullScreen={false}
        height={"calc(100% - 40px)"}
        className="mx--3"
        hideToolbar={true}
      />
    </>
  );
}
